export default __webpack_public_path__ + "static/media/a4.0cbb937a.jpg";